module.exports = __webpack_public_path__ + "static/media/mp42mp3.43cdf80e.PNG";